import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from '@azure/msal-react';

import { ThemeContextProvider } from 'common/contexts/theme-context';
import AnonymousMain from 'components/AnonymousMain';
import Main from 'components/Main';

import type { PublicClientApplication } from '@azure/msal-browser';

export default function Root({
  msalInstance,
}: {
  msalInstance: PublicClientApplication;
}) {
  return (
    <MsalProvider instance={msalInstance}>
      <ThemeContextProvider>
        <AuthenticatedTemplate>
          <Main />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <AnonymousMain />
        </UnauthenticatedTemplate>
      </ThemeContextProvider>
    </MsalProvider>
  );
}
